import dynamic from "next/dynamic";
import { useRef, useState } from "react";
import UseAnimationIos from "@/pages/api/UseAnimationIos";
import ContactForm from "./ContactForm";
const ContactSectionThird = dynamic(() => import("./ContactSectionThird"), {
  ssr: true,
  loading: () => <p className="text-center text-white">Loading...</p>,
});
import { GilroyFontDark, GilroyFontLight } from "@lib/GilroyFont";
import Link from "next/link";
import Image from "next/image";

const ContactSectionFirst = ({ isVisible, isMobile }) => {
  const [setOnScreen] = useState(false);
  const ref = useRef();
  UseAnimationIos(ref, setOnScreen);

  return (
    <>
      {/* form and  address */}
      <div className="sm:flex justify-center">
        <div className="flex flex-col   px-[2rem] sm:px-[0.75rem]  ">
          <h2
            className={` text-white text-[30px]  sm:text-[65px] font-bold ${GilroyFontDark.className} `}
          >
            Get Free Quote
          </h2>
          <p
            style={{ fontWeight: 300 }}
            className={`hidden sm:block text-white text-[24px] pt-[1.2rem] max-w-[40rem] ${GilroyFontLight.className} `}
          >
            When it comes to a dependable, professional, and cost-effective
            digital service provider. Techcelerant stands as the unrivaled
            choice. our track record specks for itselt. ano we are poised to
            demonstrate our expertise Reach out to us today to schedule a
            complimentary consultation and allow us the opportunitv to showcase
            the value we can bring to your business.
          </p>
          <p className='hidden sm:block font-bold text-[15px] text-white italic mt-4'>Highly Recommended & Trusted By</p>
    <div className='hidden sm:flex gap-3 sm:gap-8 justify-start '>
    <Link href={`https://www.google.com/search?gs_ssp=eJzj4tVP1zc0LEsyqEw3T8s2YLRSMahINLU0NEyxMEkyT0oxNjUxtDKoMDdKszQ1szA1NzdJMTA39-IpSU3OSE7NSS1KzCsBAHJXE0E&q=techcelerant&oq=techcele&gs_lcrp=EgZjaHJvbWUqDQgCEC4YrwEYxwEYgAQyBggAEEUYPDIGCAEQRRg8Mg0IAhAuGK8BGMcBGIAEMgYIAxBFGDkyBwgEEAAYgAQyBwgFEAAYgAQyBggGEEUYPDIGCAcQRRg80gEINDk4MmowajGoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0xa5911d84b7bd3541:0x72f95685774d077,1,,,,`} target='_blank'>
    <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev4.png"
                      />
                      </Link>
                      <Link href={`https://www.trustpilot.com/review/techcelerant.com`} target="_blank">
                      <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev5.png"
                      />
                      </Link>

    </div>
          {/* first section */}

          <div className="hidden sm:flex flex-wrap sm:max-w-[40vw] mt-10">
            <div className="relative text-white max-h-auto mt-2 min-w-[15rem] max-w-[15rem] sm:px-4 my-[2rem]">
              <span className="absolute top-1 border-l-[0.75rem] border-white h-full" />
              <span className="">
                <h3 className="text-[20px] pl-[1.2rem]">Email:</h3>

                <p className="text-[12px] pl-[1.2rem]">info@Techcelerant.com</p>

              </span>
            </div>
            {/* second */}
            <div className="relative text-white max-h-auto mt-2 min-w-[15rem] max-w-[15rem] sm:px-4 my-[2rem]">
              <span className="absolute top-1 border-l-[0.75rem] border-white h-full" />
              <span className="">
                <h3 className="text-[20px] pl-[1.2rem]">Address:</h3>
                <h4 className="text-[12px] pl-[1.2rem]">
                  1 Broad Avenue, <br /> Unit#4 Fairview, <br /> NJ 07022
                </h4>
              </span>
            </div>
            {/* third */}
            <div className="relative text-white max-h-auto mt-2 min-w-[15rem] max-w-[15rem] sm:px-4 my-[2rem]">
              <span className="absolute top-1 border-l-[0.75rem] border-white h-full" />
              <span className="">
                <h3 className="text-[20px] pl-[1.2rem]">Phone:</h3>

                <a href="tel:+18324761293" className="text-white">
                  <p className="text-[12px] pl-[1.2rem]"> (+1) 832 476 1293</p>
                </a>

               {/*} <a href="tel:+12013083212" className="text-white">
                  <p className="text-[12px] pl-[1.2rem]"> (+1) 201 308 3212</p>
                </a>
  */}
                <p className="text-[12px] pl-[1.2rem]"></p>
              </span>
            </div>
            {/* map starts here */}

            {/* maps ends here */}
          </div>
          {/* first section -end */}
          {!isMobile && isVisible && <ContactSectionThird />}
        </div>

        <div className="px-2 flex justify-center sm:justify-start -ml-6 sm:ml-0">
          <ContactForm />
        </div>
      </div>

      {/* connect create */}
    </>
  );
};

export default ContactSectionFirst;
